import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition } from '../../../models';
import { IThermoPackageService, IAuthorizationService, ILoggerService } from '../../../services';

class ThermoPackageStateController implements angular.IComponentController {
    isEditMode: boolean;
    package;
    packageName: string;

    static $inject = ['$state', 'authorizationService', 'thermoPackageService', 'loggerService'];

    constructor(
        private _$state: StateService,
        private _authorizationService: IAuthorizationService,
        private _thermoPackageService: IThermoPackageService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.packageName = this._$state.params.name;
        this._$state.current.data.breadcrumbs.level4 = this.packageName;
        this._thermoPackageService
            .getByName(this.packageName)
            .then(data => {
                if (data?.packageInformation) {
                    this.package = data.packageInformation;
                }
            })
            .catch(reason => {
                this._loggerService.logError(reason?.message ?? reason);
            });
    }

    canEdit() {
        return this._authorizationService.canEdit();
    }

    edit() {
        this.isEditMode = true;
    }
}

export const wtThermoPackageState: ComponentDefinition = {
    componentId: 'wtThermoPackageState',
    controller: ThermoPackageStateController,
    template: require('./thermoPackageState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};